import { NavLink } from "react-router-dom";
import JobZImage from "../../../common/jobz-img";
import SectionRecordsFilter from "../../public-user/sections/common/section-records-filter";
import { useEffect, useMemo, useState } from "react";
import { loadScript, getJobDetailUrl } from "../../../../globals/constants";
import { jobService } from "../../../../services/job-service";
import { motion, MotionPanel, MotionRow, dashboardItem } from "../../../common/dashboard-motion";

function CanAppliedJobsPage() {
    const [applications, setApplications] = useState([]);
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(true);
    const [drafts, setDrafts] = useState({});

    const _filterConfig = useMemo(() => ({
        prefix: "Applied",
        type: "jobs",
        total: String(applications.length),
        showRange: false,
        showingUpto: ""
    }), [applications.length]);

    useEffect(() => {
        loadScript("js/custom.js");
        loadApplications();
    }, []);

    const loadApplications = () => {
        jobService.myApplications()
            .then((data) => setApplications(data.applications || []))
            .catch((error) => setMessage(error.message))
            .finally(() => setLoading(false));
    };

    const sendMessage = async (application) => {
        const text = (drafts[application.id] || "").trim();
        if (!text) return;
        try {
            await jobService.sendApplicationMessage(application.id, text);
            setDrafts({ ...drafts, [application.id]: "" });
            loadApplications();
        } catch (error) {
            setMessage(error.message);
        }
    };

    return (
        <MotionRow className="twm-right-section-panel candidate-save-job site-bg-gray zz-dashboard-page zz-candidate-dashboard">
                <SectionRecordsFilter _config={_filterConfig} />
                {message && <div className="alert alert-info">{message}</div>}
                {loading ? (
                    <div className="p-a30 text-center">Loading applications...</div>
                ) : (
                    <MotionPanel className="twm-jobs-list-wrap zz-application-list">
                        {applications.length === 0 ? (
                            <div className="p-a30 text-center">No applications yet.</div>
                        ) : (
                            <ul>
                                {applications.map((application, index) => (
                                    <motion.li key={application.id} variants={dashboardItem}>
                                        <div className="twm-jobs-list-style1 mb-5">
                                            <div className="twm-media">
                                                <JobZImage src={`images/jobs-company/pic${(index % 5) + 1}.jpg`} alt="#" />
                                            </div>
                                            <div className="twm-mid-content">
                                                <NavLink to={getJobDetailUrl({ id: application.job_id, title: application.title })} className="twm-job-title">
                                                    <h4>{application.title}<span className="twm-job-post-duration"> / {formatDate(application.created_at)}</span></h4>
                                                </NavLink>
                                                <p className="twm-job-address">{application.location}</p>
                                                <span className="site-text-primary">{application.company_name || "Company"}</span>
                                            </div>
                                            <div className="twm-right-content">
                                                <div className="twm-jobs-category green"><span className="twm-bg-green">{application.status}</span></div>
                                                <div className="twm-jobs-amount">{salary(application)}</div>
                                            </div>
                                            <div className="w-100 p-t20">
                                                <div><strong>Employer:</strong> {application.employer_name || "Employer"}</div>
                                                {application.employer_note && <div><strong>Employer note:</strong> {application.employer_note}</div>}
                                                {application.interview_at && <div><strong>Interview:</strong> {formatDateTime(application.interview_at)}</div>}
                                                <div className="m-t10">
                                                    {(application.messages || []).length === 0 ? <div>No messages yet.</div> : (application.messages || []).map((item) => (
                                                        <div key={item.id} className="dashboard-messages-box m-b5">
                                                            <div className="dashboard-message-area"><h5>{item.sender_name || item.sender_role}<span>{formatDateTime(item.created_at)}</span></h5><p>{item.message}</p></div>
                                                        </div>
                                                    ))}
                                                    <textarea className="form-control m-b10" rows={2} placeholder="Reply to employer about this application" value={drafts[application.id] || ""} onChange={(event) => setDrafts({ ...drafts, [application.id]: event.target.value })} />
                                                    <button type="button" className="site-button" onClick={() => sendMessage(application)}>Send Reply</button>
                                                </div>
                                            </div>
                                        </div>
                                    </motion.li>
                                ))}
                            </ul>
                        )}
                    </MotionPanel>
                )}
        </MotionRow>
    )
}

function salary(job) {
    if (job.salary_min && job.salary_max) return `${formatInr(job.salary_min)} - ${formatInr(job.salary_max)}`;
    if (job.salary_min) return formatInr(job.salary_min);
    return "Salary disclosed";
}

function formatInr(value) {
    return `₹${Number(value || 0).toLocaleString("en-IN")}`;
}

function formatDate(value) {
    if (!value) return "";
    return new Date(value).toLocaleDateString();
}

function formatDateTime(value) {
    if (!value) return "";
    return new Date(value).toLocaleString();
}

export default CanAppliedJobsPage;
